import LxcError from "~/core/models/LxcError.class";
import type { CampaignOperationMgr } from "~/modules/campaign/models/CampaignOperationMgr.interface";
import campaignOperationMgrService from "~/modules/campaign/services/campaignOperationMgr.service";

export function useCancelCampaign({
  organizationCode,
}: {
  organizationCode?: number;
}) {
  const isLoading = ref(false);
  const error: Ref<LxcError | undefined> = ref();
  const result: Ref<CampaignOperationMgr | undefined> = ref();

  async function cancelCampaign(campaignUid: string) {
    isLoading.value = true;
    error.value = undefined;
    result.value = undefined;

    const response = await campaignOperationMgrService.cancel(
      campaignUid,
      organizationCode,
    );

    if (LxcError.check(response)) {
      error.value = response;
    } else {
      result.value = response;
    }

    isLoading.value = false;
  }

  return {
    isLoading,
    error,
    result,
    cancelCampaign,
  };
}
